import { useSwipeNavigation } from '../hooks/useSwipeNavigation';

const SwipeContainer = ({ children, className = '' }) => {
  const swipeHandlers = useSwipeNavigation();

  return (
    <div
      {...swipeHandlers}
      className={`swipe-container ${className}`}
      style={{ 
        height: '100%', 
        width: '100%',
        touchAction: 'pan-y' // Enable vertical scroll while allowing horizontal swipe
      }}
    >
      {children}
    </div>
  );
};

export default SwipeContainer;